(() => {
  const preorder = /\bpre[\s-]?order\b|\bpre[\s-]?sale\b|预售|預售|预订|預訂/i;
  const normalSale = /\badd to cart\b|\bbuy now\b|加入购物车|加入購物車|立即购买|立即購買/i;
  const soldOut = /\bsold out\b|\bout of stock\b|售罄|缺货|缺貨/i;
  const visible = (element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const schemaSelector = 'script[data-el-product-schema], script[data-el-review-schema]';

  function sync() {
    document.querySelectorAll('script[data-el-product-schema]').forEach((schemaElement) => {
      const productId = schemaElement.dataset.productId;
      const scope = schemaElement.closest('product-info');
      if (!scope || scope.dataset.productId !== productId) return;
      const buttons = Array.from(scope.querySelectorAll('button[name="add"], .product-form__submit, [class*="timesact" i] button[type="submit"]')).filter(visible);
      if (!buttons.length) return;
      const preButton = buttons.find((button) => !button.disabled && preorder.test(button.innerText || button.textContent));
      const saleButton = buttons.find((button) => !button.disabled && normalSale.test(button.innerText || button.textContent));
      const outButton = buttons.find((button) => button.disabled && soldOut.test(button.innerText || button.textContent));
      const button = preButton || saleButton || outButton;
      if (!button) return;
      const state = preButton ? 'PreOrder' : saleButton ? 'InStock' : 'OutOfStock';
      const form = button.form || button.closest('form') || scope.querySelector('form[data-type="add-to-cart-form"]');
      const variantInput = form && form.querySelector('[name="id"]');
      const variantId = variantInput ? variantInput.value : schemaElement.dataset.selectedVariant;
      if (!variantId) return;
      const availability = `https://schema.org/${state}`;
      document.querySelectorAll(schemaSelector).forEach((element) => {
        if (element.dataset.productId !== productId) return;
        try {
          const schema = JSON.parse(element.textContent);
          const isReview = element.hasAttribute('data-el-review-schema');
          if (isReview && scope.dataset.updateUrl === 'false') return;
          const offers = isReview ? [schema.itemReviewed.offers] : schema.offers;
          let changed = false;
          offers.forEach((offer) => {
            if (!isReview && new URL(offer.url, location.href).searchParams.get('variant') !== variantId) return;
            if (offer.availability === availability) return;
            offer.availability = availability;
            changed = true;
          });
          if (changed) element.textContent = JSON.stringify(schema);
        } catch (error) {
          // A third-party script can replace a schema while it is being read.
        }
      });
    });
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sync();
    });
  }
  const observer = new MutationObserver((records) => {
    if (records.some((record) => !record.target.parentElement?.closest(schemaSelector) && !record.target.matches?.(schemaSelector))) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'disabled', 'value', 'aria-hidden'] });
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);
  schedule();
})();
